import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import type { FactBoxProps } from "./FactBox.d";

export const FactBoxPart = (props: ComponentProps<PartData>) => {
  const { container, margin, backgroundColor, content } =
    (props.data as FactBoxProps) ?? {};

  return (
    <div className={`${container} ${margin}`}>
      <div
        className={`factbox ${backgroundColor}`}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
};

export default FactBoxPart;
